<template>
  <div>
    <div class="upload-box">
      <img  class="img-size" :src="require('@/assets/upload-icon.png')" />
      <div style="text-align: center">
        <p class="download"><el-link @click="download" type="primary">[点击下载]</el-link><strong>大文件及批量上传客户端</strong></p>
        <p class="text"><span>请下载客户端进行上传，目前仅支持客户端上传。</span></p>
        <p class="text"><span>客户端支持批量快速上传和断点续传</span></p>
      </div>
    </div>
  </div>
</template>
<script>
import { detectOS } from '@/utils'
import { getDownloadUrl } from '@/resource/api'
export default {
  name: 'upload',
  methods: {
    async download (e) {
      try {
        const { result: { downloadUrl } } = await getDownloadUrl(detectOS())
        window.location.href = downloadUrl
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
<style lang="less" scoped>
  .download {
    .el-link {
      font-weight: bold;
    }
    strong {
      padding-left: 5px;
      color: #444;
      font-size: 14px;
    }
  }
  .img-size{
    width: 100px;
    height: auto;
  }
  .text {
    border-width: 0px;
    width: 287px;
    white-space: nowrap;
    font-size: 14px;
    color: #666;
  }
  .upload-box{
    margin: 160px auto 0;
    width: 300px;
    text-align: center;
  }
</style>
